import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import "../styles.css"
function Header() {
  return (
    <Navbar className="header fixed-top" variant="light" bg="light">
      <Container>
        <Navbar.Brand onClick={() =>(window.location.reload())}>
          <i class="fa-solid fa-sun-cloud"></i>
          <strong>The Weather App</strong>
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}

export default Header;
